import { Component, OnInit } from '@angular/core';
import { Meta, Title } from "@angular/platform-browser";
import { Router } from '@angular/router';
import { Globals } from '../../Globals';
import { ProfileService } from '../_services/profile.service';
import { AuthenticationService } from '../_services/authentication.service';

@Component({
  selector: 'profile', 
  templateUrl: './profile.component.html', 
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
	model;
  updateStatus;
  error;
  loading;
  constructor(private router: Router, private title: Title, private globals: Globals, private profileService: ProfileService, private authenticationService: AuthenticationService) {}
  ngOnInit() {
    this.title.setTitle('Profile');
    this.profileService.getProfile().subscribe(result => {
      this.model = result.code === 200 ? result.data : {};
    });
  }
  updateProfile(){
    if(this.loading===true) return;
    this.loading = true;
    this.updateStatus = null;
  	this.profileService.updateProfile(this.model).subscribe(result => {
      this.loading = false;
      this.updateStatus = result.code;
    });
  }
  logout(){
    this.authenticationService.logout();
    this.router.navigate(['/auth/login']);
  }
}
